/** Static copy from PCL 25-26 31-08-26.xlsm — sheets R0 / R0.1 / R1–R13 */

import type {G0Page} from '@/pages/components/audit-program/g-section/constants';
import type {JBreakdownPage, JRemark} from '@/pages/components/audit-program/j-section/constants';

export type RSectionPageCode =
    | 'R0' | 'R0.1'
    | 'R1' | 'R2' | 'R3' | 'R4' | 'R5' | 'R6' | 'R7' | 'R8' | 'R9' | 'R10' | 'R11' | 'R12' | 'R13';

export const R_SECTION_PAGES: RSectionPageCode[] = ['R0', 'R0.1', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'R10', 'R11', 'R12', 'R13'];

export const R_PAGE_TITLES: Record<RSectionPageCode, string> = {
    R0: 'Audit programme - Related party transactions',
    'R0.1': 'Supplementary procedures - Related party transactions',
    R1: 'Audit and other professional fee',
    R2: 'Bank charges (admin expense)',
    R3: 'Business registration fee',
    R4: 'Director\'s remuneration',
    R5: 'Electricity and water',
    R6: 'Entertainment',
    R7: 'MPF contributions',
    R8: 'Office expense',
    R9: 'Preliminary expenses',
    R10: 'Rental expense',
    R11: 'Secretarial fee',
    R12: 'Travelling expenses',
    R13: 'Virtual office',
};

export type RProgrammePage = G0Page;
export type RExpensePage = JBreakdownPage;

export const R0_PAGE: RProgrammePage = {
    title: 'AUDIT PROGRAMME - RELATED PARTY TRANSACTIONS',
    rows: [
        {id: 'r1', kind: 'section', num: '', text: 'General', level: 0},
        {id: 'r2', kind: 'main', num: '1', text: 'Review information provided by those charged with governance and management identifying the names of all known related parties and perform the following procedures in respect of the completeness of this information:', level: 0},
        {id: 'r3', kind: 'sub', num: '(a)', text: 'Review the permanent file and prior year working papers for names of known related parties.', level: 1},
        {id: 'r4', kind: 'sub', num: '(b)', text: 'Review the company\'s procedures for identification of related parties.', level: 1},
        {id: 'r5', kind: 'sub', num: '(c)', text: 'Enquire as to the affiliation of those charged with governance and officers with other companies.', level: 1},
        {id: 'r6', kind: 'sub', num: '(d)', text: 'Review shareholder records to determine the names of principal shareholders or, if appropriate, obtain a listing of principal shareholders from the share register.', level: 1},
        {id: 'r7', kind: 'sub', num: '(e)', text: 'Review minutes of the meetings of shareholders and those charged with governance and other relevant statutory records such as the register of directors\' interests.', level: 1},
        {id: 'r8', kind: 'sub', num: '(f)', text: 'Enquire of other auditors currently involved in the audit, predecessor auditors or internal auditors as to their knowledge of additional related parties.', level: 1},
        {id: 'r9', kind: 'sub', num: '(g)', text: 'Review the company\'s tax returns and other information supplied to the tax authorities.', level: 1},
        {id: 'r10', kind: 'sub', num: '(h)', text: 'Review invoices and correspondence from lawyers for indications of the existence of related parties or related party transactions.', level: 1},
        {id: 'r11', kind: 'sub', num: '(i)', text: 'Enquire of the names of all pension and other trusts established for the benefit of employees and the names of their management.', level: 2},
        {id: 'r12', kind: 'main', num: '2', text: 'Consider the adequacy of control activities over the authorisation and recording of related party transactions and transactions outside the normal course of business.', level: 0},
        {id: 'r13', kind: 'main', num: '3', text: 'Ensure all members of the audit team are made aware of all identified related parties and informed of all newly identified ones.', level: 0},
        {id: 'r14', kind: 'section', num: '', text: 'Directors', level: 0},
        {id: 'r15', kind: 'main', num: '4', text: 'Prepare a schedule of movements on the loan account for each director and other connected person.', level: 0},
        {id: 'r16', kind: 'main', num: '5', text: 'Review all month-end sales and purchase ledger balances to identify any accounts in the names of related parties.', level: 0},
        {id: 'r17', kind: 'main', num: '6', text: 'Enquire as to the interest of the directors\' in other companies, unincorporated businesses and partnerships.', level: 0},
        {id: 'r18', kind: 'section', num: '', text: 'Transactions', level: 0},
        {id: 'r19', kind: 'main', num: '7', text: 'Review the accounting and other records for large or unusual transactions or balances, in particular transactions recognized at or near the end of the financial period and for those outside the normal course of business. For example:', level: 0},
        {id: 'r20', kind: 'sub', num: '(a)', text: 'Transactions with abnormal terms.', level: 1},
        {id: 'r21', kind: 'sub', num: '(b)', text: 'Transactions that appear to lack a logical business reason for their occurrence.', level: 1},
        {id: 'r22', kind: 'sub', num: '(c)', text: 'Transactions in which substance differs from form.', level: 1},
        {id: 'r23', kind: 'sub', num: '(d)', text: 'Transactions processed or approved in a non-routine manner.', level: 1},
        {id: 'r24', kind: 'sub', num: '(e)', text: 'High volume or significant transactions with certain customers or suppliers as compared with others.', level: 1},
        {id: 'r25', kind: 'sub', num: '(f)', text: 'Unrecorded transactions such as the receipt or provision of management services at no charge.', level: 1},
        {id: 'r26', kind: 'sub', num: '(g)', text: 'Sales transactions with unusually large discounts.', level: 1},
        {id: 'r27', kind: 'sub', num: '(h)', text: 'Circular transactions - sales with a commitment to repurchase.', level: 1},
        {id: 'r28', kind: 'sub', num: '(i)', text: 'Transactions under contracts whose terms are changed before expiry.', level: 2},
        {id: 'r29', kind: 'sub', num: '(j)', text: 'Bank and legal confirmations obtained as part of audit procedures.', level: 1},
        {id: 'r30', kind: 'sub', num: '(k)', text: 'Minutes of meetings of shareholders and of those charged with governance.', level: 1},
        {id: 'r31', kind: 'sub', num: '(l)', text: 'Such other records or documents as considered necessary in the circumstances of the entity.', level: 1},
        {id: 'r32', kind: 'main', num: '8', text: 'Discuss the nature, purpose and terms of any unusual transactions with management and enquire as to whether related parties are involved.', level: 0},
        {id: 'r33', kind: 'section', num: '', text: 'Significant transactions outside the normal course of business', level: 0},
        {id: 'r34', kind: 'main', num: '9', text: 'Ensure that any previously unidentified related party transactions outside the normal course of business are documented in the Assertion Risk Action Plan (C8.3) as high risks.', level: 0},
        {id: 'r35', kind: 'main', num: '10', text: 'Inspect the underlying contracts or agreements, if any, and evaluate whether;', level: 0},
        {id: 'r36', kind: 'sub', num: '(a)', text: 'Related parties are involved.', level: 1},
        {id: 'r37', kind: 'sub', num: '(b)', text: 'The business rationale suggests they have been entered into to engage in fraudulent financial reporting.', level: 1},
        {id: 'r38', kind: 'sub', num: '(c)', text: 'The transaction terms are consistent with management explanations.', level: 1},
        {id: 'r39', kind: 'sub', num: '(d)', text: 'The transactions have been properly accounted for and disclosed.', level: 1},
        {id: 'r40', kind: 'sub', num: '(e)', text: 'The transactions have been properly authorized. Where no such formal controls exist obtain management representations as to the validity of the transactions and consider management involvement in the transactions.', level: 1},
        {id: 'r41', kind: 'section', num: '', text: 'Transactions at arms length', level: 0},
        {id: 'r42', kind: 'main', num: '11', text: 'Where the financial statements state that a related party transaction was conducted at arms length:', level: 0},
        {id: 'r43', kind: 'sub', num: '(a)', text: 'Consider the appropriateness of management\'s process for supporting this assertion.', level: 1},
        {id: 'r44', kind: 'sub', num: '(b)', text: 'Verify the source of and/or external data supporting the assertion. Test for accuracy, completeness and relevance.', level: 1},
        {id: 'r45', kind: 'sub', num: '(c)', text: 'Assess the reasonableness of the assumptions made.', level: 1},
        {id: 'r46', kind: 'section', num: '', text: 'Previously unidentified or undisclosed related parties or significant related party transactions', level: 0},
        {id: 'r47', kind: 'main', num: '12', text: 'Where potential related parties or potential related party transactions are identified that management had not previously identified or disclosed, determine whether the underlying circumstances confirm the existence of the relationship or transaction.', level: 0},
        {id: 'r48', kind: 'main', num: '13', text: 'Where confirmation is obtained :', level: 0},
        {id: 'r49', kind: 'sub', num: '(a)', text: 'Promptly inform the audit team of these details.', level: 1},
        {id: 'r50', kind: 'sub', num: '(b)', text: 'Ask management to identify all transactions with the newly identified related party.', level: 1},
        {id: 'r51', kind: 'sub', num: '(c)', text: 'Enquire as to why these had not been identified previously and why any controls in place failed to pick them up.', level: 1},
        {id: 'r52', kind: 'sub', num: '(d)', text: 'Review accounting records for further transactions with this party.', level: 1},
        {id: 'r53', kind: 'sub', num: '(e)', text: 'Verify the terms of the transactions and ensure that they have been appropriately accounted for and disclosed.', level: 1},
        {id: 'r54', kind: 'sub', num: '(f)', text: 'Enquire into the nature of the relationship.', level: 1},
        {id: 'r55', kind: 'sub', num: '(g)', text: 'Ask management whether there are any further undisclosed related parties or transactions.', level: 1},
        {id: 'r56', kind: 'sub', num: '(h)', text: 'Where management has intentionally failed to disclose related parties and significant related party transactions consider whether it is necessary to re-evaluate the reliability of all management responses and representations.', level: 1},
        {id: 'r57', kind: 'section', num: '', text: 'Disclosure', level: 0},
        {id: 'r58', kind: 'main', num: '14', text: 'Obtain sufficient appropriate audit evidence as to whether identified related party transactions have been appropriately accounted for and disclosed.', level: 0},
        {id: 'r59', kind: 'main', num: '15', text: 'Obtain sufficient appropriate audit evidence that disclosures in the financial statements relating to control of the company are properly stated.', level: 0},
        {id: 'r60', kind: 'note', num: 'Note', text: 'Note. This may include obtaining corroboration from the ultimate controlling party.', level: 1},
        {id: 'r61', kind: 'section', num: '', text: 'Management representations', level: 0},
        {id: 'r62', kind: 'main', num: '16', text: 'In respect of related party relationships and transactions obtain written representations from management concerning:', level: 0},
        {id: 'r63', kind: 'sub', num: '(a)', text: 'The completeness of information provided;', level: 1},
        {id: 'r64', kind: 'sub', num: '(b)', text: 'The appropriateness of the accounting treatment;', level: 1},
        {id: 'r65', kind: 'sub', num: '(c)', text: 'The adequacy of disclosure in the financial statements.', level: 1},
        {id: 'r66', kind: 'section', num: '', text: 'Letter of comment', level: 0},
        {id: 'r67', kind: 'main', num: '17', text: 'Where those charged with governance include people other than those involved in management include details of any significant matters arising from the audit of related party transactions in the letter of comment.', level: 0},
        {id: 'r68', kind: 'section', num: '', text: 'Conclusion', level: 0},
        {id: 'r69', kind: 'main', num: '18', text: 'Consider whether sufficient appropriate audit evidence concerning all related parties and transactions with such parties and the appropriateness of the accounting treatment and disclosures in the financial statements has been obtained.', level: 0},
        {id: 'r70', kind: 'main', num: '19', text: 'Consider whether there are any points which need to be included in a letter of representation or letter of comment and record on A5 or A6 as appropriate.', level: 0},
        {id: 'r71', kind: 'main', num: '20', text: 'Review the planned extent of reliance on internal controls in this area and consider whether this remains appropriate.', level: 0},
        {id: 'r72', kind: 'main', num: '21', text: 'Assess whether the initial risk assessment should be revised in view of the audit evidence obtained. Record details of any necessary adjustments on B6 or B9. Consider the impact on the remainder of the audit work and on any work undertaken to date.', level: 0},
    ],
};

export const R0_1_PAGE: RProgrammePage = {
    title: 'SUPPLEMENTARY PROCEDURES - RELATED PARTY TRANSACTIONS',
    rows: [
        {id: 'r1', kind: 'section', num: '', text: 'Related Party Transactions', level: 0},
        {id: 'r2', kind: 'main', num: '1', text: 'Obtain a confirmation of amount and terms of repayment from each director / connected person.', level: 0},
        {id: 'r3', kind: 'main', num: '2', text: 'Perform collectability review (impairment test) for the amounts receivable where applicable.', level: 0},
        {id: 'r4', kind: 'main', num: '3', text: 'Enquire if there are any material interests of directors\' in transactions, arrangements or contracts of significance entered into by a specified undertaking of the company and consider whether the fact should be disclosed in directors\' report.', level: 0},
        {id: 'r5', kind: 'main', num: '4', text: 'For related party transactions, consider obtaining third party confirmation of transactions and balances.', level: 0},
    ],
};

const R_REMARKS: JRemark[] = [
    {tick: '<', text: 'Per bank statement'},
    {tick: 'V', text: 'Checked to invoices'},
    {tick: '✓', text: 'Confirmed and agreed'},
    {tick: 'b', text: "Per last year's working paper"},
    {tick: '>', text: 'Per ledger'},
    {tick: '^', text: 'Casting checked'},
];

export const R1_PAGE: RExpensePage = {
    title: 'Audit and other professional fee',
    subtitle: 'Expenses',
    amountLabel: 'Audit and other professional fee',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R2_PAGE: RExpensePage = {
    title: 'Bank charges (admin expense)',
    subtitle: 'Expenses',
    amountLabel: 'Bank charges (admin expense)',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R3_PAGE: RExpensePage = {
    title: 'Business registration fee',
    subtitle: 'Expenses',
    amountLabel: 'Business registration fee',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R4_PAGE: RExpensePage = {
    title: 'Director\'s remuneration',
    subtitle: 'Expenses',
    amountLabel: 'Director\'s remuneration',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R5_PAGE: RExpensePage = {
    title: 'Electricity and water',
    subtitle: 'Expenses',
    amountLabel: 'Electricity and water',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R6_PAGE: RExpensePage = {
    title: 'Entertainment',
    subtitle: 'Expenses',
    amountLabel: 'Entertainment',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R7_PAGE: RExpensePage = {
    title: 'MPF contributions',
    subtitle: 'Expenses',
    amountLabel: 'MPF contributions',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R8_PAGE: RExpensePage = {
    title: 'Office expense',
    subtitle: 'Expenses',
    amountLabel: 'Office expense',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R9_PAGE: RExpensePage = {
    title: 'Preliminary expenses',
    subtitle: 'Expenses',
    amountLabel: 'Preliminary expenses',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R10_PAGE: RExpensePage = {
    title: 'Rental expense',
    subtitle: 'Expenses',
    amountLabel: 'Rental expense',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R11_PAGE: RExpensePage = {
    title: 'Secretarial fee',
    subtitle: 'Expenses',
    amountLabel: 'Secretarial fee',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R12_PAGE: RExpensePage = {
    title: 'Travelling expenses',
    subtitle: 'Expenses',
    amountLabel: 'Travelling expenses',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};
export const R13_PAGE: RExpensePage = {
    title: 'Virtual office',
    subtitle: 'Expenses',
    amountLabel: 'Virtual office',
    breakdownTitle: 'Breakdown',
    cyLabel: 'Current year HK$',
    lyLabel: 'Last year HK$',
    conclusionLabel: 'Conclusion',
    conclusionPlaceholder: 'The amount is fairly presented',
    remarksTitle: 'Remark',
    remarks: R_REMARKS,
    blankBreakdownRows: 12,
};

/** Map page code → expense page default content. */
export const R_EXPENSE_PAGES: Partial<Record<RSectionPageCode, RExpensePage>> = {
    R1: R1_PAGE,
    R2: R2_PAGE,
    R3: R3_PAGE,
    R4: R4_PAGE,
    R5: R5_PAGE,
    R6: R6_PAGE,
    R7: R7_PAGE,
    R8: R8_PAGE,
    R9: R9_PAGE,
    R10: R10_PAGE,
    R11: R11_PAGE,
    R12: R12_PAGE,
    R13: R13_PAGE,
};
